import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import _get from 'lodash/get'
import _map from 'lodash/map'
import _reduce from 'lodash/reduce'
import EmptyBar from '../../_library/EmptyBar'
import LoadingBar from '../../_library/LoadingBar'
import SortableTable from '../../_library/SortableTable'
import { RadioGroup, Radio } from '../../_library/RadioGroup'
import { getTableColumns } from '../../utils/sortableTableUtils'
import {
  currencyNormalizerCreator,
  createFixedFloatNormalizer,
} from '../../../_common/core/validation/normalizers'
import { getPerfomanceData } from '../../../_common/core/http_services'
import { showAxiosError } from '../../utils/messenger'

const PerformanceCharges = ({ event, user }) => {
  const [data, setData] = useState(null)
  const [totals, setTotals] = useState(null)
  const [loading, setLoading] = useState(true)
  const [selectedTab, setSelectedTab] = useState('charges')

  const [sortBy] = useState({ column: 'quantity', asc: true })
  const tableColumns = useMemo(
    () =>
      getTableColumns([
        { label: 'Charge Description', key: 'short_description' },
        { label: 'Quantity', key: 'quantity' },
        {
          label: 'Amount (excl. fees)',
          key: 'net_amount',
          normalizer: value =>
            currencyNormalizerCreator(getActiveCurrencySymbol(event ?? null))(
              createFixedFloatNormalizer(2)(parseFloat(value)),
            ),
        },
        {
          label: 'Revenue (excl. fees)',
          key: 'revenue',
          normalizer: value =>
            currencyNormalizerCreator(getActiveCurrencySymbol(event ?? null))(
              createFixedFloatNormalizer(2)(parseFloat(value)),
            ),
        },
      ]),
    [event],
  )

  const fetchAdditionalCharges = async (eventId, filters) => {
    try {
      setLoading(true)
      const res = await getPerfomanceData(eventId, 'charges', filters)
      const resData = _map(_get(res, 'charges'), item => ({
        ...item,
        revenue: parseFloat(item.net_amount) * parseInt(item.quantity),
      }))
      const totalQuantity = _reduce(resData, (sum, item) => sum + parseInt(item.quantity), 0)
      const totalGrossIncome = _reduce(resData, (sum, item) => sum + parseFloat(item.revenue), 0)

      setData(resData)
      setTotals({ totalQuantity, totalGrossIncome })
    } catch (err) {
      showAxiosError(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (event?.id) {
      const params = selectedTab === 'fees' ? { type: 'resale_fee' } : {}
      fetchAdditionalCharges(event?.id, params)
    }
  }, [event, selectedTab])

  return (
    <div>
      {user.isSuperAdmin && (
        <RadioGroup name="charges" selectedValue={selectedTab} onChange={setSelectedTab}>
          <Radio name="charges" value="charges" label="Additional Charges" />
          <Radio name="fees" value="fees" label="Resale Fees" />
        </RadioGroup>
      )}
      <div className="table-caption">
        <img
          alt="no-data"
          className="section-main-heading"
          src={asset('/resources/images/event/performance/additional-charges-ico.svg')}
        />
        {selectedTab === 'charges' ? 'Additional Charges' : 'Resale Fees'}
      </div>
      <div className="table-background">
        {loading ? (
          <LoadingBar key="loadingBar" title="" />
        ) : Boolean(data?.length) ? (
          <SortableTable
            data={data}
            tableColumns={tableColumns}
            sortBy={sortBy}
            customFootbar={
              <tfoot>
                <tr>
                  <td>
                    <strong>Total:</strong>
                  </td>
                  <td>{totals?.totalQuantity}</td>
                  <td />
                  <td>
                    {currencyNormalizerCreator(getActiveCurrencySymbol(event ?? null))(
                      createFixedFloatNormalizer(2)(parseFloat(totals?.totalGrossIncome)),
                    )}
                  </td>
                  <td />
                </tr>
              </tfoot>
            }
            enableSort={false}
            enableCopyTable={true}
            disableMobileView={true}
          />
        ) : (
          <EmptyBar />
        )}
      </div>
    </div>
  )
}

export default connect(state => ({
  user: _get(state, 'auth.user', {}),
}))(PerformanceCharges)
